<canvas #qrCodeCanvas class="qr-code-component"></canvas>